/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';

import * as types from 'src/shared/domain/topic/action/topicActionTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const fetchRelatedTopics = (state: Object, action: Object) => {
  const { params, result } = action;

  const userId =
    params && typeof params === 'object' ? params.related_user : null;

  if (userId) {
    return {
      ...state,
      [params.related_user]: {
        result,
      },
    };
  }
  return state;
};

export default createReducer(initialState, {
  [types.FETCH_TOPICS_SUCCESS]: fetchRelatedTopics,
});
